import React from 'react'
import './Course.css'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import img1 from '../assets/course/12101001.jpg'
import img2 from '../assets/course/12101002.jpg'
import img3 from '../assets/course/12101003.jpg'
import tr1 from '../assets/others/11102067.webp'
import img4 from '../assets/others/11102069.jpg'
import cr1 from "../assets/course/image-1.png"
import cr2 from "../assets/course/image-1.png"
import cr3 from "../assets/course/image-1.png"
import cr4 from "../assets/course/image-1.png"
import cr5 from "../assets/course/image-1.png"
import img5 from "../assets/course/image-1.png"
import arrow from '../assets/arrow-down-right.svg'
import icn1 from '../assets/icons/user-star.png'
import Accordion from 'react-bootstrap/Accordion'
import Companysec from '../Components/Companysec/Companysec'
import Offersec from '../Components/Offersec/Offersec'
import icncheck from '../assets/icons/check-circle-bl.svg'
import instimg from '../assets/others/11102038.jpg'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import "react-multi-carousel/lib/styles.css";
import Partnersec from '../Components/Partnersec/Partnersec'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Helmet } from 'react-helmet-async'
import Videoreview from '../Components/Videoreviewsec/Videoreview'
import Corejob from '../Components/Corejob/Corejob'
library.add(fas)




const Coursedetail = () => {
  return (
    <div>
       <Helmet>
        <title>Physical Design Training | RTL to GDSII Training, DFT Training | Physical Design Training Institutes with Placement</title>
        <meta name="description" content="Enroll in Physical Design Training from RTL to GDSII, and DFT Training. Top institutes offer job-oriented courses with placement. Advance your VLSI career today!" />
        <link rel="canonical" href="https://www.takshila-vlsi.com/product/physical-design/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Physical Design Training | RTL to GDSII Training, DFT Training | Physical Design Training Institutes with Placement" />
        <meta property="og:description" content="Enroll in Physical Design Training from RTL to GDSII, and DFT Training. Top institutes offer job-oriented courses with placement. Advance your VLSI career today!" />
        <meta property="og:url" content="https://www.takshila-vlsi.com/product/physical-design/" />
        <meta property="og:site_name" content="Takshila VLSI" />
        <meta property="article:modified_time" content="2024-08-10T07:42:16+00:00" />
        <meta property="og:image" content="https://www.takshila-vlsi.com/wp-content/uploads/2020/02/image.jpg" />
        <meta property="og:image:width" content="1000" />
        <meta property="og:image:height" content="563" />
        <meta property="og:image:type" content="image/jpeg" />
        <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
        
        <Header/>

        <main>
            <section class="section-banner pg-banner ws-section pt-5 bg-14">
              <div class="container text-center">
                          <div class="row justify-content-around p-5 pb-0">
                              <div class="col-md-12">
                                <div class="pg-title-sec pl-r-12">
                                    <h1 className='pg-title pb-3'>VLSI Chip <span className='bg-txt'>Design</span> Physical Design Courses
                                    </h1>
                                    <p className='pg-title-desc mb-5'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.</p>
                                </div>
                              </div>
                              <div class="col-md-12 align-self-center">
                                                  <button class="btn-primary btn-icon" href="index.html#about">Enroll Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                               </div>
                          </div>
                          <div class="row justify-content-center img-radius">
                            <div class="col-md-2 align-self-end">
                            <img src={img1} alt=''/>
                            </div>
                            <div class="col-md-2 align-self-end">
                            <div className='course-bnr-bx bg-8 radius-1'>
                                    <h4 className='course-bnr-title'>100%</h4>
                                    <p className='course-bnr-desc'>Learners feel more confident when applying for jobs</p>
                                </div>
                            </div>
                            <div class="col-md-3 align-self-end">
                            <img src={img2} alt=''/>
                            </div>
                            <div class="col-md-2 align-self-end">
                            <div className='course-bnr-bx bg-7 radius-1'>
                                    <h4 className='course-bnr-title'>100%</h4>
                                    <p className='course-bnr-desc'>Learners became better at their job</p>
                                </div>
                            
                            </div>
                            <div class="col-md-2 align-self-end">
                            <img src={img3} alt=''/>
                            </div>
                          </div>
              </div>
          </section>
          <section className='course-desc p-5 bg-14'>
                <div class="container text-center">
                         <div class="row justify-content-around text-center">
                              <div class="col-md p-5">
                                    <h2 className='ws-section_heading pd-03'><span className='font-thin'>VLSI Chip Design Training & Physical Design </span>Courses in Bangalore/ Hyderabad</h2>
                              </div>
                          </div>
                          <div class="row justify-content-around">
                              <div class="col-md">
                                    <h3 className='pb-3 txt-3'>COURSE DESCRIPTION</h3>
                                    <div className='text-left text-xl'>
                                    <p>Physical Design Training course mainly focused on giving complete hands on experience to physical design and physical verification training flow with latest tools and full lab practice. By end of the course your will learn to work in Linux environment, understand complete physical design flow from partitioning, floor planning, power planning, timing analysis, clock tree synthesis, routing of a functional unit blocks to physical verification and sign-off checks.</p>

                                    <p>It is extensive training for students in the field of electrical and electronics. Takshila VLSI ranks among the top 10 physical design training institutes in the Bangalore.
                                    </p></div>
                              </div>
                          </div>
                </div>
          </section>
          <section className='highlight-section p-5 bg-14'>
            <div class="container bg-9 p-5 radius-1">
                <div className='txt-3 mb-3'>Industry Standard VLSI and DFT Training</div>
                <div className='mb-5'>
                <div className='txt-2 mb-2'>Eligibility</div>
                <div class="row row-cols-2">
                    <div className='col'>
                    <div className='icon-left-bx d-flex'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>B.E/B.Tech in ECE/EEE.</div>
                    </div>
                    </div>
                    <div className='col'>
                    <div className='icon-left-bx d-flex'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>M.E/M.Tech/M.S in VLSI/Embedded Systems/Digital Electronics.</div>
                    </div>
                    </div>
                </div>
                </div>
                <div className='mb-5'>
                <div className='txt-2 mb-2'>Course Duration</div>
                <div class="row row-cols-2">
                    <div className='col'>
                    <div className='icon-left-bx d-flex'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>5 Months</div>
                    </div>
                    </div>
                   
                </div>
                </div>
                <div>
                <div className='txt-2 mb-2'>Course Highlights</div>
                <div class="row">
                    <div className='col'>
                    <div className='icon-left-bx d-flex mb-2'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>Hands-on exposure to physical design flow with industry standard EDA tools.</div>
                    </div>
                  
                    <div className='icon-left-bx d-flex mb-2'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>Deep understanding of various methodologies and technologies used.</div>
                    </div>
                    
                    <div className='icon-left-bx d-flex mb-2'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>24X7 Lab Support with Lab practice handouts and course material delivery.</div>
                    </div>
                    
                    <div className='icon-left-bx d-flex mb-2'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>Industry standard project execution from RTL to gdsii training, Lab practice and theory sessions under the guidance of industry expert with 12+ years of experience.</div>
                    </div>
                    
                    <div className='icon-left-bx d-flex mb-2'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>Soft skills development, complete suite of job oriented physical design training with 100% placement assistance.</div>
                    </div>
                    </div>
                </div>
                </div>
                    
            </div>
          </section>

          <section className='author-section p-5 bg-14'>
          <div className='container'>
          <div class="row">
                <div class="col-9 align-self-center bg-3 dark-bg p-5 mr--10 mt-5">
                <h2 class="ws-section_heading mb-3">About Instructors</h2>
                <p>Mr. Chaitanya comes with 12+ years of experience in RTL to GDSII implementation of IP's, Sub-System's and SoC's. Hands on experience in RTL2GDSII flow of multiple complex blocks like PCIe, SATA, DDR_PHY, HBM_PHY, processor's and also have experience on DFT design flows and Design Constraints development.</p>
                <div class="wpb_wrapper">
                <div class="row">
                        <div class="col m-3 p-4 bg-white radius-1">
                        <p><strong>Expertise Areas:</strong></p>
                <p>Low power implementation and strategies<br/>
                Mode specific Design constraints development<br/>
                Clock Tree Building at Block and Full-Chip<br/>
                Full-Chip Timing Analysis and Timing Closure<br/>
                Logical Equivalence Check and Low power checks<br/>
                SI/Cross_talk analysis</p>
                        </div>
                        <div class="col m-3 p-4 bg-white radius-1">
                            <p><strong>Technology Process Worked On:</strong><br/> 
                            <strong>Finfet Technologies:</strong> 7nm and 16nm<br/>
                    <strong>Nominal Technologies:</strong> 28nm, 40nm, 65nm, 90nm &amp; 130nm.</p>
                    <p><strong>IC Foundries Worked with:</strong> TSMC, UMC, GF</p>
                    
                        </div>
                        <div class="col m-3 p-4 bg-white radius-1">
                            
                    <p><strong>EDA tools known for Physical design :</strong></p> <p>Genus/RTL_Compiler/DC, Conformal, Encounter/Innovus, QRC Extraction, PrimeTime/Tempus<br/>
                    Physical verification tools known: Redhawk/Voltus, Calibre DRC, Calibre LVS</p>
                        </div>
                    </div>
                        </div>
                </div>
                <div class="col img-radius">
                <img src={instimg} alt=''/>
                </div>
            </div>
            </div>
          </section>

          <section className='curriculum-section pt-5'>
             <div className='container'>
                <div class="row justify-content-center mb-5">
                <div class="col-7 text-center">
                <h3 class="ws-section_heading pb-03 txt-3">Physical design training institute 
                with placement</h3>
                </div>
                </div>
                <div class="row mb-5">
                    <div class="col-8">
                    <div class="ws-section_heading pb-03 txt-3 mb-0">VLSI PD Curriculum</div>
                    </div>
                    <div class="col-4 align-self-center">
                     <a class="btn-primary btn-icon" href="#about">Download Brouchure<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></a>
                    
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                    <div className='curriculum-accord accordion'>
                            <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Module 1: Basics of Unix/Linux</Accordion.Header>
                                <Accordion.Body>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Introduction and Working knowledge of UNIX/LINUX commands</div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>File handling skills in UNIX/LINUX</div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Introduction to programming languages used in IC-Design </div>
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Module 2: Basics of CMOS</Accordion.Header>
                                <Accordion.Body>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>MOSFET Operation, stick diagram, IC fabrication process </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Formation of Digital (NAND AND OR NOR etc) logic using CMOS</div>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>Module 3: Design and Tech libraries</Accordion.Header>
                                <Accordion.Body>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Characterization of Digital standard cells and Library file information  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Technology File information, LEF file information, QRC Techfile process  
                                </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Basics RTL coding and RTL language like Verilog, VHDL, SystemVerilog  
                                </div>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>Module 4: Synthesis Part-1</Accordion.Header>
                                <Accordion.Body>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Inputs and Outputs understanding  
                                </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Constraints development and understanding  
                                </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Optimization techniques (uniqify, preserve, flatten )  
                                </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>DFT basics  
                                </div>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>Module 5: Synthesis Part-2</Accordion.Header>
                                <Accordion.Body>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Low power implementation techniques  
                                </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Sanity checks like checkDesign, lint report  
                                    </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Derive environment features  
                                </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Generic, map, incremental  
                                </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Wireload model, PLE, Physical, Spatial  
                                </div>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>Module 6: Logical Equivalence</Accordion.Header>
                                <Accordion.Body>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Inputs and outputs understanding  
                                </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Intent and comparison understanding  
                                </div>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header>Module 7: Static Timing Analysis Part-1</Accordion.Header>
                                <Accordion.Body>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Basic understanding of transition/slew, capacitance, leakage power, internal power, On-Chip-Variation (derate, AOCV, LVF)  
                                </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Library file difference NLDM, CCS, ECSM, LVF  
                                </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Timing concepts understanding like setup, hold, recovery, removal, pulse_width, clock gating check  
                                </div>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="7">
                                <Accordion.Header>Module 8: Static Timing Analysis Part-2</Accordion.Header>
                                <Accordion.Body>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>PLL jitter understanding and uncertainty calculations  
                                </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>IO budgetting  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Different Timing Modes understanding  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>ECO generation </div>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="8">
                                <Accordion.Header>Module 9: Physical Design</Accordion.Header>
                                <Accordion.Body>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Floorplaning concepts and IO placement  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Power planning  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Placement strategies like region, fence, blockages, pading, bump, dont touch, filler gap  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>DRV optimization, Buffer tree synthesis  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Clock tree synthesis and clock latency calculations  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Routing design and optimization  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Antenna  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>ECO Timing closure and implementation cycle  </div>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="9">
                                <Accordion.Header>Module 10: Physical Design Verification
                                </Accordion.Header>
                                <Accordion.Body>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Design Rule Checks understanding and importance  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Layout Versus Schematic and difference with respect to LEC  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Electrical Rule Checks  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>IR Drop analysis - Static and Dynamic  </div>
                                </div>
                               
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="10">
                                <Accordion.Header>Module 11: Industry standard Project Execution
                                </Accordion.Header>
                                <Accordion.Body>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Industry Standard Physical Design Live Project  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Sanity checks like checkDesign, lint report  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Derive environment features  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Generic, map, incremental  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Wireload model, PLE, Physical, Spatial  </div>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="11">
                                <Accordion.Header>Module 12: Mock Interviews & Personality improvement
                                </Accordion.Header>
                                <Accordion.Body>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Low power implementation techniques  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Sanity checks like checkDesign, lint report  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Derive environment features  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Generic, map, incremental  </div>
                                </div>
                                <div className='icon-left-bx d-flex mb-2'>
                                    <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                    <div className='icn-heading'>Wireload model, PLE, Physical, Spatial  </div>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            </Accordion>
                            </div>
                    </div>
                </div>

             </div>
                    </section>

                    <section className='video-section p-5'>
            <div class="container text-center">
                 <div className='row'>
                    <div className='col text-center'>
                    <h2 class="ws-section_heading">Physical Design Demo Videos</h2>
                  </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col">
                        <iframe
                            width="100%"
                            height="250"
                            src={`https://www.youtube.com/embed/KnUliEaCxvk`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Embedded youtube"
                            poster="hqdefault"
                        />
                    </div>
                    <div class="col">
                    <iframe
                        width="100%"
                        height="250"
                        src={`https://www.youtube.com/embed/_f0y3t_4XpE`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Embedded youtube"
                        poster="hqdefault"
                      />
                    </div>
                    <div class="col">
                    <iframe
                        width="100%"
                        height="250"
                        src={`https://www.youtube.com/embed/_f0y3t_4XpE`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Embedded youtube"
                        poster="hqdefault"
                      />
                    </div>
                    <div class="col">
                    <iframe
                        width="100%"
                        height="250"
                        src={`https://www.youtube.com/embed/_f0y3t_4XpE`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Embedded youtube"
                        poster="hqdefault"l
                      />
                    </div>
                </div>
            </div>
          </section>


                    <Companysec/>
                    <section className='ws-section pb-5 bg-white'>
                        <div class="container text-center">
                        <div class="row justify-content-around">
                                        <div class="col-6">
                                            <div className='trainer-box'>
                                            
                                                <div className='trainer-img img-radius'>
                                                <img src={tr1} alt=''/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 text-left">
                                            <h2 className='mb-4'>5 Real Reasons Why Progressively More People Are Rushing Our Physical Design Training</h2>
                                            <div className='course-accord dark-bg'>
                                        <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>1. We Are a Physical Design Training Institute With . 100% Placement</Accordion.Header>
                                            <Accordion.Body>
                                            As the foremost of all physical design institutes in Bangalore, our students rest assured of 100% placement in the best product or service based companies after completing their physical design course with us. Also, we have the best of all physical design training institutes in Hyderabad which does the same for our teeming students. Our 100% placement feature has seen some of our past students building the most amazing careers in the VLSI industry. That’s why we are ahead of all physical design training institutes in Hyderabad and around the world.</Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>2. Course Content</Accordion.Header>
                                            <Accordion.Body>
                                            Our physical Design Training focuses providing a full hands-on experience of physical design training and physical verification training flow with complete laboratory practice using the most trending tools presently available in the industry. This is quite unlike other physical design training institutes in Bangalore or Hyderabad. Certainly, we’ve gone ahead and none can catch up with us.<br/>

            <br/>After you complete this course, you will the flow of physical design from partitioning, power planning, clock tree synthesis, physical verification, floor planning, timing analysis, routing of functional unit blocks, and sign-off checks. This also makes you a complete master of Physical Design. So, which other physical design training institutes in Hyderabad offer content that goes this deep? We give our students RTL to GDSii training so they can work between varying necessary file formats.
            
            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header>3. The Best Physical Design Training Institute</Accordion.Header>
                                            <Accordion.Body>
                                            Yes, we’re certainly the best physical design training institute around and yet we’re a low cost physical design training institute. If you compare the little we charge to the quality of our instructors, lessons, and materials, you will understand that we certainly offer lots more value for the money our students pay. This alone has helped ensure that we are seen by all industry experts as one of the best physical design training institutes in India and around the whole world.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="3">
                                            <Accordion.Header>4. We are among the India’s Top 10 Physical Design Institutes</Accordion.Header>
                                            <Accordion.Body>
                                            Apart from being among the top 10 physical design institutes in India, we’re also the no 1 physical design training institute in Bangalore. This shows the whole world is beginning to recognize our amazing contributions to the training and placement of the VLSI industry’s future leaders. We are among the top 10 physical design training institutes because of our truly extensive training program for top students in the electricals and electronics field.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="4">
                                            <Accordion.Header>5. The Course’s Features</Accordion.Header>
                                            <Accordion.Body>
                                            One of the key reasons for this course’s continuously rising popularity is its key features. The major ones are;<br/><br/>
            <ul>
                <li>
            A hands-on introduction to the flow of physical design training with best tools that fully meet industry standards.</li>
            <li>24/7 laboratory support with the delivery of course materials and lab practice handouts via the best online physical design courses.</li>
            <li>The development of soft skills with a complete suite of physical design courses online which, are job-oriented with 100% placement assistance after the completion of the course.</li>
            <li>Truly deep knowledge of varying technologies and methodologies used in physical design including DFT training.</li>
            <li>Project execution that meets all industry standards from RTL to GDSii training, to theory as well as lab practice sessions that are under the guidance of the industry’s foremost experts who feature more than twelve years of VLSI teaching experience.</li>
            </ul></Accordion.Body>
                                        </Accordion.Item>
                                        </Accordion>
                                        </div>
                                        </div>
                                    </div>
                        </div>
                    </section>
                    
                    <section className='why-sec p-5'>
                    <div class="container text-center">
                                    <div class="row justify-content-around text-center">
                                        <div class="col-md p-5">
                                                <h2 className='ws-section_heading pd-03'>Why Takshila VLSI?</h2>
                                        </div>
                                    </div>

                                    <div class="row row-cols-3">
                                            <div class="col text-left">
                                                <div className='course-icon-bx bg-lt radius-1 mb-4'>
                                                    <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                                        <div className='bx-title align-self-center'>Expert Trainers and Curriculum
                                                        </div>
                                                        <div className='bx-icn'><img src={icn1} alt=''/></div>
                                                    </div>
                                                    <div className='icon-bx-bottom'>
                                                        <p>We collaborate with trainers who have over 15+ years in the industry. All our
            courses are professionally designed and are job-oriented to satisfy the
            demands of the VLSI industry. Our courses are designed by
            Professionals.
            </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col text-left">
                                            <div className='course-icon-bx bg-drk dark-bg radius-1'>
                                                    <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                                        <div className='bx-title align-self-center'>Offline/Online Courses & Affordable Fee
                                                        </div>
                                                        <div className='bx-icn'><img src={icn1} alt=''/></div>
                                                    </div>
                                                    <div className='icon-bx-bottom'>
                                                        <p>Our offline/online VLSI courses are designed to ensure that our students
            gain access to training materials and classrooms at their convenience. We
            offer state-of-the-art courses at very affordable prices.
            </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col text-left">
                                            <div className='course-icon-bx bg-lt radius-1'>
                                                    <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                                        <div className='bx-title align-self-center'>100% Placement Assistance
                                                        </div>
                                                        <div className='bx-icn'><img src={icn1} alt=''/></div>
                                                    </div>
                                                    <div className='icon-bx-bottom'>
                                                        <p>At Takshila VLSI technologies we provide placement support for our students
            till they get placed. We collaborate with over 200+ top-level semiconductor
            companies that provide us with placement opportunities for our students.
            </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col text-left">
                                            <div className='course-icon-bx bg-drk-3 dark-bg radius-1'>
                                                    <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                                        <div className='bx-title align-self-center'>Powerful EDA Tools
                                                        </div>
                                                        <div className='bx-icn'><img src={icn1} alt=''/></div>
                                                    </div>
                                                    <div className='icon-bx-bottom'>
                                                        <p>We utilize industrial standard EDA tools for hands-on training of our students.
            During your period as a trainee in our VLSI institute, EDA tools are accessible
            24×7 through our vpn service.
            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col text-left">
                                <div className='course-icon-bx bg-lt radius-1'>
                                        <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                            <div className='bx-title align-self-center'>Superior Training infrastructure and Methodology
                                            </div>
                                            <div className='bx-icn'><img src={icn1} alt=''/></div>
                                        </div>
                                        <div className='icon-bx-bottom'>
                                            <p>We use an unique training methodology for our students with 70% of the course time allocated to the labs, mini-projects, and the final projects. However, the other 30% is allocated to imparting the technologies to our student.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col text-left">
                                <div className='course-icon-bx bg-drk-4 dark-bg radius-1'>
                                        <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                            <div className='bx-title align-self-center'>Value for Money
                                            </div>
                                            <div className='bx-icn'><img src={icn1} alt=''/></div>
                                        </div>
                                        <div className='icon-bx-bottom'>
                                            <p>We teach you all advanced courses at a reasonable cost. We offer you more for less. With comprehensive lessons, expert guidance, and hands-on experience, you’ll gain the skills you need to succeed without breaking the bank.

                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
           </div>
          </section>
          <Offersec/>

          <section className='corejob-section p-5 bg-14'>
                <div class="container text-center">
                                <div className='row pb-3'>
                                    <div className='col text-center'>
                                    <h2 class="ws-section_heading">Core Job Opportunities</h2>
                                  </div>
                                </div>
                                <div className='row'>
                                    <div className='col-4 mb-4'>
                                    <div class="career-box d-flex p-3 radius-1 dark-bg">
                                                  <img src={cr1} alt="movie" />
                                                  <h6>Physical Design Engineering</h6>
                                                  </div>
                                     </div>
                                     <div className='col-4'>
                                    <div class="career-box d-flex p-3 radius-1 dark-bg">
                                                  <img src={cr2} alt="movie" />
                                                  <h6>Physical Design Engineering</h6>
                                                  </div>
                                     </div>
                                     <div className='col-4'>
                                    <div class="career-box d-flex p-3 radius-1 dark-bg">
                                                  <img src={cr3} alt="movie" />
                                                  <h6>Physical Design Engineering</h6>
                                                  </div>
                                     </div>
                                     <div className='col-4'>
                                    <div class="career-box d-flex p-3 radius-1 dark-bg">
                                                  <img src={cr4} alt="movie" />
                                                  <h6>Physical Design Engineering</h6>
                                                  </div>
                                     </div>
                                     <div className='col-4'>
                                    <div class="career-box d-flex p-3 radius-1 dark-bg">
                                                  <img src={cr5} alt="movie" />
                                                  <h6>Physical Design Engineering</h6>
                                                  </div>
                                     </div>
                                     <div className='col-4'>
                                    <div class="career-box d-flex p-3 radius-1 dark-bg">
                                                  <img src={cr1} alt="movie" />
                                                  <h6>Physical Design Engineering</h6>
                                                  </div>
                                     </div>
                                </div>
                            </div>
          </section>

          <section className='ws-section pb-5 bg-white'>
            <div class="container text-center">
            <div className='row pb-3'>
                    <div className='col text-center'>
                    <h2 class="ws-section_heading">Connect With Us</h2>
                  </div>
                </div>
            <div class="row justify-content-around">
                            <div class="col-5">
                                <div className='trainer-box'>
                                    <div className='content-box wd-80 d-flex bg-path'>
                                    <div className='trainer-content'>
                                    <h5 className='trainer-title text-left'>Join us & achieve <br/>
                                    your goals.</h5>
                                    </div>
                                    </div>
                                    <div className='trainer-img img-radius'>
                                    <img src={img4} alt=''/>
                                    </div>
                                 </div>
                            </div>
                            <div class="col-6">
                                
                                <iframe
                                    aria-label='Register Now'
                                    width="100%"
                                    height="850"
                                    src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                    frameborder="0" 
                                   
                                />
                               
                            </div>
                        </div>
            </div>
          </section>

          
          <section className='course-faq-section ws-section p-5 bg-14'>
            <div className='container'>
                <div className='row'>
                    <div className='col text-center'>
                    <h2 class="ws-section_heading">Frequently Asked Questions</h2>
                  </div>
                </div>
                <div className='row justify-content-center pb-5'>
                    <div className='col-10'>
                    <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>1. What is the uniqueness of your Physical Design Course?</Accordion.Header>
                                <Accordion.Body>Enroll in our Physical Design Course to become an expert in VLSI physical design. Gain practical experience using tools from the first day of class. Having access to the world of chip design feels like having a VIP pass!

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>2. Who should consider enrolling in the VLSI Physical Design Training?</Accordion.Header>
                                <Accordion.Body>
                                If you have graduated in ECE, EEE, or a similar area and are eager to explore the details of chip design, then this course is perfect for you! If you’re a recent graduate or have some experience, our VLSI physical design training will provide you with the advantage you require.


                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>3. What will I learn in the Advanced Physical Design module?</Accordion.Header>
                                <Accordion.Body>
                                In our Advanced Physical Design module, you will immerse yourself in the most intricate elements of physical design. We provide comprehensive coverage of floor planning, power planning, clock tree synthesis, and routing.


                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>4. How does your Physical Design Certification benefit me?</Accordion.Header>
                                <Accordion.Body>
                                Our Physical Design Certification is more than just a document. It’s a valuable opportunity. It demonstrates to employers your capability to succeed in physical design by showcasing your skills and knowledge. It also helps you grab job opportunities with your certification.


                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>5. Are the Physical Design Lessons hands-on or theoretical?</Accordion.Header>
                                <Accordion.Body>
                                You will have the opportunity to not only learn about physical design but also apply it through hands-on experience with actual industry tools and real projects.


                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>6. Will this course help me with job placement?</Accordion.Header>
                                <Accordion.Body>
                                Definitely! In our Physical Design Course, We are committed to assisting you with placement opportunities and leveraging our strong reputation as a leading institute to help you secure a job in the VLSI sector.


                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header>7. What support will you provide during the VLSI Physical Design Training?</Accordion.Header>
                                <Accordion.Body>
                                We provide a 24-hour availability lab so that you can practice at your convenience during the VLSI Physical Design Training.
                                </Accordion.Body>
                            </Accordion.Item>
                            </Accordion>
                    </div>
                </div>
                <div class="row justify-content-center mt-5">
                        <div class="col-9">
                            <div class="callaction-2">
                                <div class="row">
                                <div class="col-7">
                                    <h2>Don't see your questions ? answered here?</h2>
                                </div>
                                <div class="col-4 align-self-center text-center">
                                <button class="btn-primary btn-icon ms-0" href="index.html#about">Contact Us<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                                </div>
                                </div> 
                            </div>
                        </div>
                    </div>
            </div>
          </section>

          
          <Videoreview/>
          <Enrollaction/>
          <Partnersec/> 
        </main>
        <Footer/>
    </div>
  )
}

export default Coursedetail